import { Component, OnInit } from '@angular/core';
import { SetupService } from '@core/services/setup';
import { DEPARTMENT_TYPE_YOUTH } from 'src/app/core/constants';

@Component({
    selector: 'app-youth-home',
    templateUrl: './youth-home.component.html',
    styleUrls: ['./youth-home.component.scss'],
})
export class YouthHomeComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Juvenil
     */
    public departmentType: string = DEPARTMENT_TYPE_YOUTH;

    constructor(public setupService: SetupService) {}

    ngOnInit(): void {}
}
